import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StarIcon = styled.span<{ $empty?: boolean }>`
  display: inline-flex;
  align-items: center;
  color: ${({ $empty }) => ($empty ? 'var(--t-horizontal-vertical-rule)' : 'var(--t-brand-fg-color)')};
`;

export const ScreenReaderText = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;